export default __webpack_public_path__ + "static/media/wretchedheartcurse.8c49e1bf.png";